export const STATUS_DRAFT = 0;
export const STATUS_PUBLISH = 1;
export const STATUS_PENDING = 2;

export default {
  STATUS_DRAFT,
  STATUS_PUBLISH,
  STATUS_PENDING
};
